import './table.css';

import React from 'react';

import { cn } from '@/services/utils';

interface TableRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
    selected?: boolean;
}

const TableRow = React.forwardRef<
    HTMLTableRowElement,
    TableRowProps
>(({ className, selected, ...props }, ref) => {
    return (
        <tr
            ref={ref}
            className={cn(
                'table-row !tw-border-b tw-border-b-gray-300 tw-transition-colors tw-z-0',
                {
                    'selected': selected,
                },
                className,
            )}
            {...props}
        />
    );
});

TableRow.displayName = 'TableRow';

export { TableRow };
